export default {
  path: 'drivers/:id',
  name: 'Person',
  component: () => import(/* webpackChunkName: "people" */ '../views/PersonView.vue')
}
